export default __webpack_public_path__ + "static/media/keyvisual-markgraeflerland.59c4a138.jpg";